import { fullscreenStyle } from "@tamagui/stacks";
import { setupReactNative, styled } from "@tamagui/web";
import { ScrollView as ScrollViewNative } from "react-native";
setupReactNative({
  ScrollView: ScrollViewNative
});
const ScrollView = styled(ScrollViewNative, {
  name: "ScrollView",
  scrollEnabled: true,
  variants: {
    fullscreen: {
      true: fullscreenStyle
    }
  }
});
export {
  ScrollView
};
//# sourceMappingURL=ScrollView.js.map
